import React from 'react'
import { Typography } from '@mui/material'
import { Alert, AlertTitle } from '@mui/material'

type Props = {
  classes?: any;
  title?: string;
  text?: string;
  severity?: string;
};

const InPageAlert = ({
  classes = {},
  title = 'Errors',
  text = '',
  severity = 'error',
  ...others
}: Props) => {
  return (
// @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'OverridableStringUnion<AlertColor, AlertPropsColorOverrides> | undefined'.
    <Alert severity={severity} className={classes.alertRoot} {...others}>
      <AlertTitle>
        <Typography className={classes.alertTitleText}>{title}</Typography>
      </AlertTitle>
      <Typography>{text}</Typography>
    </Alert>
  )
}

export default InPageAlert
